import { GlobalService } from 'src/app/global.service';
import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode, MatDialog } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-online-payment-transaction-report',
  templateUrl: './online-payment-transaction-report.component.html',
  styleUrls: ['./online-payment-transaction-report.component.scss']
})
export class OnlinePaymentTransactionReportComponent implements OnInit {

  from_date: Date;
  to_date: Date;
  pdf_data: any;
  is_document_available: boolean = true;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  option_type_list = [{ "display_name": 'Cash', "value": 'agent' }, { "display_name": 'Card', "value": 'icustomer' }]
  selected_option: string;
  title: any;

  constructor(private httpservice: HttpService, private dom: DomSanitizer, private global: GlobalService) {
    this.title = this.global._active_display_name;
   }

  getClicked(){
    let data_dict = {
      'from_date': this.from_date,
      'to_date': this.to_date,
      'option_type': this.selected_option
    }
    console.log(data_dict)
    this.is_document_available = false;
    this.document_file = null;
    this.httpservice.serveOnlinePaymentTransationReport(data_dict).subscribe((data) => {
      console.log(data)
      this.pdf_data = this.dom.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data['pdf']);
      this.document_file = data;
        this.is_document_available = true;
      }, (error) => {
        alert('Data not avaliable')
        this.is_document_available = true;
      });
    }

    downloadClicked() {
      const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
      const downloadLink = document.createElement("a");
      const fileName = this.document_file['file_name'];
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    }

  ngOnInit() {
  }

}
